import React, { ReactNode, use, useContext, useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { appState } from "@/app/appState";
import { adminGetAgents, chatCreateArtifact, chatCreateEvent } from "@/api";
import { agent_list_item } from "@/app/typing/agents";
import { StateColumnSingle, Modal, ChatListItem, ActionHandler } from "../UI/tools";
import { observer } from "mobx-react-lite";
import { usePathParam } from "../path-params";
import { NavLink } from "react-router-dom";
import { page_artifact_list_item } from "@/app/typing/artifacts";
import { Outlet } from "react-router-dom";
import { chatState } from "@/app/chatState";
import { conversationSource } from "@/app/workspace/chat/applyCreatedArtifact";
import { Add_new, AddObject, AddUser, AddEvent, Chat, Dark, Home, Light, Sign_in, Sign_out, User, Settings } from "../UI/svgs";
import TagEntry from "@/app/workspace/tags/entry";
import { RunningChats } from "./runningChats";
import { ChatMessage, ChatMessageBlockUserAction } from "@/app/typing/chat";

const NAV_ICON_SIZE = 18; // keep in sync with --icon-size (1.125rem)

interface NavbarProps {
    pages: page_artifact_list_item[]

}

export const NavBarGroup = ({ children, isVertical }: { children: ReactNode, isVertical?: boolean }) => {
    return (
        <div className={`nav-group ${isVertical ? 'nav-group-vertical' : ''}`}>
            {children}
        </div>
    );
}

const WorkspaceNavbar = observer(({ pages }: NavbarProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [conversationId, setConversationId] = usePathParam("chat");
    const [newChatModal, setNewChatModal] = useState<{ title: string; body: React.ReactNode; action?: () => void } | undefined>();
    const [workspaceModal, setWorkspaceModal] = useState<{ title: string; body: React.ReactNode; action?: () => void } | undefined>();

    // Derived state from location
    const tagIds = location.pathname.startsWith("/workspace/chat-") ?
        location.pathname.replace("/workspace/chat-", "").split("-").map(x => parseInt(x)).filter(x => !isNaN(x))
        : [];

    const hasCalendar = tagIds.length > 0 && tagIds.some(id => appState.tags.find(t => t.id === id)?.has_calendar === true);

    const setTagIds = (action: number[] | ((prev: number[]) => number[])) => {
        const newIds = typeof action === 'function' ? action(tagIds) : action;
        if (newIds.length === 0) {
            navigate("/workspace/chat");
        } else {
            navigate(`/workspace/chat-${newIds.sort((a, b) => a - b).join("-")}`);
        }
    };

    const createDraftEvent = async () => {
        try {
            const res: any = await chatCreateEvent({
                body: {
                    tag_ids: tagIds
                }
            })

            if (res.data) {
                const message: ChatMessage = res.data
                const prev = chatState.conversation
                const newConversation = [...prev, {
                    role: message.role,
                    agent_id: message.agent_id,
                    content: [{ ...message, conversation_id: message.conversation_id }],
                }];

                chatState.setConversation(newConversation);
                const object_id = (message.content[0] as ChatMessageBlockUserAction).object_id
                chatState.chatObjects.update([{
                    key: { type: "event", id: object_id }, value: {
                        msg_id: message.id,
                        id: object_id,
                        created_at: res.data.created_at,
                        last_updated_at: res.data.last_updated_at,
                        label: appState.t("nav.newEvent"),
                        isSelected: true,
                        edit: true,
                        type: "event",
                        event: {}
                    }
                }])

                chatState.setSelectedObjectKey({
                    type: "event",
                    id: object_id
                }, false);
            }
        }
        catch {

        }
    }

    const createDraftArtifact = async () => {
        try {
            const res: any = await chatCreateArtifact({
                body: {
                    tag_ids: tagIds,
                    // File the new note under whatever source is open, if any.
                    ...conversationSource(),
                }
            })

            if (res.data) {
                const message: ChatMessage = res.data
                const prev = chatState.conversation
                const newConversation = [...prev, {
                    role: message.role,
                    agent_id: message.agent_id,
                    content: [{ ...message, conversation_id: message.conversation_id }],
                }];

                chatState.setConversation(newConversation);
                // await _getChat() // TODO Try to make appending to conversation directly properly reactive
                const object_id = (message.content[0] as ChatMessageBlockUserAction).object_id
                console.log("NEW ARTIFACT CREATED", object_id, res.data)
                chatState.chatObjects.update([{
                    key: { type: "artifact", id: object_id }, value: {
                        msg_id: message.id,
                        id: object_id,
                        created_at: res.data.created_at,
                        last_updated_at: res.data.last_updated_at,
                        label: appState.t("nav.newArtifact"),
                        isSelected: true,
                        edit: true,
                        type: "artifact",
                        artifact: { is_draft: true }
                    }
                }])

                chatState.setSelectedObjectKey({
                    type: "artifact",
                    id: object_id
                }, false);
            }
        }
        catch {

        }
    }

    const [fouldout, setFouldout] = useState(false);
    const [createFoldout, setCreateFoldout] = useState(false);


    type navpath = {
        action: string | (() => void);
        name: string;
        bg?: string;
        funq?: () => void
    };


    const Navlink = (val: navpath) => {

        return (

            <div key={val.name}
                onClick={() => {
                    typeof val.action === 'string' ? navigate(val.action) : val.action();
                    val.funq ? val.funq() : ''
                    setFouldout(false)
                }}
                className={`menu-item ${val.bg ? 'menu-item-accent' : ''}`}>
                <div

                    className="group">

                    <p className="l">{val.name}</p>
                </div>
            </div>
        );
    };

    return (
        <div className="h-full w-full overflow-hidden flex flex-col min-h-0">

            <div className="select-none">







                <nav className="navbar">
                    <div className="navbar-row">
                        <div className="flex flex-row gap-1 w-full">

                            <div className="flex flex-row items-start justify-start px-1 grow">
                                <div className="pl-1 flex flex-col h-full justify-center">
                                    <p
                                        className="navbar-brand"
                                        onClick={() => navigate(appState.user ? "/workspace" : "/")}
                                    >eyka</p>

                                </div>



                            </div>

                            {/* Desktop groups - hidden on mobile */}
                            <div className="hidden md:flex md:flex-row md:gap-1">
                                {appState.user && <RunningChats />}
                                {appState.user && (
                                <NavBarGroup>
                                    {chatState.mounted && (
                                        <ActionHandler
                                            title={appState.t("nav.createArtifact")}
                                            keysTrigger="ctrlKey+n"
                                            funq={async () => {
                                                createDraftArtifact()

                                            }}
                                            disabled={!chatState.conversationId}
                                            className="btn-ghost"

                                        >
                                            <AddObject size={NAV_ICON_SIZE} />
                                        </ActionHandler>
                                    )}
                                    {chatState.mounted && (
                                        <ActionHandler
                                            title={appState.t("nav.createEvent")}
                                            funq={async () => {
                                                createDraftEvent()
                                            }}
                                            disabled={!chatState.conversationId || tagIds.length === 0}
                                            className="btn-ghost"
                                        >
                                            <AddEvent size={NAV_ICON_SIZE} />
                                        </ActionHandler>
                                    )}
                                    <ActionHandler
                                        title={appState.t("nav.addClient")}
                                        funq={() => {
                                            setWorkspaceModal({
                                                title: appState.t("nav.addNewClient"),
                                                body: (
                                                    <TagEntry id={-1} setId={() => { setWorkspaceModal(undefined) }} isModal={true} initialValues={{ scope: 'me', permission_type: 7, attributes: { phone: '', email: '', is_client: true } }} />
                                                )
                                            });
                                        }}
                                        disabled={false}
                                        className="btn-ghost"

                                    ><AddUser size={NAV_ICON_SIZE} />
                                    </ActionHandler>

                                </NavBarGroup>
                                )}



                                {appState.user && (
                                <div className={`menu mt-3 top-3 right-[95px] ${fouldout ? "" : "hidden"}`}>

                                    {
                                        appState.user?.active_organisation ?
                                            [
                                                appState.user.active_organisation.permission_type >= 2 ? { action: "/workspace/tags", name: appState.t("nav.tags") } : undefined,
                                                appState.user.active_organisation.permission_type >= 2 ? { action: "/workspace/artifacts", name: appState.t("nav.artifacts") } : undefined,
                                                appState.user.active_organisation.permission_type >= 2 ? { action: "/workspace/documents", name: appState.t("nav.documents") } : undefined,
                                                appState.user.active_organisation.permission_type >= 2 ? { action: "/workspace/events", name: appState.t("nav.events") } : undefined,
                                                // appState.user.active_organisation.permission_type >= 1 ? { action: "/workspace/chat", name: "Chat", funq: () => { setConversationId(undefined) } } : undefined,
                                            ].map((x) => {
                                                return x ? <Navlink {...x} key={x.name} /> : undefined;
                                            })
                                            :
                                            null
                                    }
                                </div>
                                )}
                                {appState.user && (
                                <>
                                <NavBarGroup>

                                    <ActionHandler
                                        title={appState.t("nav.chat")}
                                        funq={() => {
                                            navigate("/workspace/chat");
                                            setConversationId(undefined);
                                            setFouldout(false);
                                        }}
                                        disabled={chatState.mounted}
                                        className="btn-ghost"

                                    ><Chat size={NAV_ICON_SIZE} /></ActionHandler>

                                    <ActionHandler
                                        title={appState.t("nav.profile")}
                                        funq={() => {
                                            navigate("/workspace/profile");
                                            setFouldout(false);
                                        }}
                                        disabled={location.pathname == "/workspace/profile"}
                                        className="btn-ghost"

                                    ><User size={NAV_ICON_SIZE} /></ActionHandler>

                                    {appState.user?.active_organisation ? (
                                        <ActionHandler
                                            title={appState.t("nav.settings")}
                                            funq={() => {
                                                navigate("/workspace/settings");
                                                setFouldout(false);
                                            }}
                                            disabled={location.pathname.startsWith("/workspace/settings")}
                                            className="btn-ghost"
                                        ><Settings size={NAV_ICON_SIZE} /></ActionHandler>
                                    ) : undefined}

                                    <ActionHandler
                                        title={appState.t("nav.home")}
                                        funq={() => {
                                            navigate("/workspace");
                                            setFouldout(false);
                                        }}
                                        disabled={location.pathname == "/workspace"}
                                        className="btn-ghost"

                                    ><Home size={NAV_ICON_SIZE} /></ActionHandler>

                                    {appState.user?.is_super_admin && (
                                        <ActionHandler
                                            title={appState.t("nav.summariserEval")}
                                            funq={() => {
                                                navigate("/workspace/summarisation-tests");
                                                setFouldout(false);
                                            }}
                                            disabled={location.pathname == "/workspace/summarisation-tests"}
                                            className="btn-ghost"
                                        >
                                            Eval
                                        </ActionHandler>
                                    )}
                                    {chatState.mounted && appState.user?.is_super_admin && (
                                        <ActionHandler
                                            title={appState.t("nav.debugView")}
                                            funq={() => {
                                                chatState.setShowDebugView(!chatState.showDebugView);
                                            }}
                                            disabled={false}
                                            className="btn-ghost"
                                        >
                                            Chat Debug
                                        </ActionHandler>
                                    )}
                                </NavBarGroup>


                                <NavBarGroup>

                                    <ActionHandler
                                        title={appState.t("nav.toggleTheme")}
                                        funq={() => {
                                            appState.theme == "dark" ? appState.setTheme("light") : appState.setTheme("dark")
                                        }}
                                        disabled={false}
                                        className="btn-ghost"

                                    >{appState.theme == "dark" ? <Light size={NAV_ICON_SIZE} /> : <Dark size={NAV_ICON_SIZE} />}</ActionHandler>

                                    <ActionHandler
                                        title={appState.t("nav.menu")}
                                        funq={() => {
                                            setFouldout(p => !p)
                                        }}
                                        disabled={false}
                                        className="btn-ghost"

                                    >

                                        <svg className="h-fit w-fit" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth={1.5} stroke="currentColor">

                                            <g className={`${fouldout ? 'hidden' : ''}`}>
                                                <line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line>
                                            </g>
                                            <g className={`${fouldout ? '' : 'hidden'}`}>
                                                <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
                                            </g>
                                        </svg>
                                    </ActionHandler>
                                </NavBarGroup>
                                </>
                                )}
                                {(appState.user || location.pathname !== "/signin") && (
                                <NavBarGroup>
                                    {appState.user && (
                                    <div className="flex flex-col">

                                        <small className="pl-1">
                                            <b>{appState.user.full_name}</b>
                                        </small>
                                        <small className="pl-1">
                                            <i>{appState.organisations?.filter(x => x.id == appState.user?.active_organisation.id).map(x => x.name)}</i>
                                        </small>
                                    </div>
                                    )}

                                    <ActionHandler
                                        title={appState.user ? appState.t("nav.signOut") : appState.t("nav.signIn")}
                                        funq={() => {
                                            appState.user ? appState.logout() : navigate("/signin")
                                        }}
                                        disabled={false}
                                        className="btn-ghost"
                                    >{appState.user ? <Sign_out size={NAV_ICON_SIZE} /> : <Sign_in size={NAV_ICON_SIZE} />}</ActionHandler>

                                </NavBarGroup>
                                )}
                            </div>{/* end desktop groups */}

                            {/* Mobile compact bar */}
                            <div className="flex md:hidden flex-row gap-1 items-center">
                                {appState.user ? (
                                <NavBarGroup>
                                    <ActionHandler
                                        title={appState.t("nav.create")}
                                        funq={() => { setCreateFoldout(p => !p); setFouldout(false); }}
                                        disabled={false}
                                        className="btn-ghost"
                                    >
                                        <Add_new size={NAV_ICON_SIZE} />
                                    </ActionHandler>
                                    <ActionHandler
                                        title={appState.t("nav.menu")}
                                        funq={() => { setFouldout(p => !p); setCreateFoldout(false); }}
                                        disabled={false}
                                        className="btn-ghost"
                                    >
                                        <svg className="h-fit w-fit" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" strokeWidth={1.5} stroke="currentColor">
                                            <g className={`${fouldout ? 'hidden' : ''}`}>
                                                <line x1="4" x2="20" y1="12" y2="12"></line><line x1="4" x2="20" y1="6" y2="6"></line><line x1="4" x2="20" y1="18" y2="18"></line>
                                            </g>
                                            <g className={`${fouldout ? '' : 'hidden'}`}>
                                                <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
                                            </g>
                                        </svg>
                                    </ActionHandler>
                                </NavBarGroup>
                                ) : location.pathname !== "/signin" && (
                                <NavBarGroup>
                                    <ActionHandler
                                        title={appState.t("nav.signIn")}
                                        funq={() => {
                                            navigate("/signin")
                                        }}
                                        disabled={false}
                                        className="btn-ghost"
                                    ><Sign_in size={NAV_ICON_SIZE} /></ActionHandler>
                                </NavBarGroup>
                                )}
                            </div>

                            {/* Mobile create foldout */}
                            {appState.user && (
                            <div className={`menu md:hidden top-[2.5rem] right-[8px] ${createFoldout ? "" : "hidden"}`}>
                                {chatState.mounted && (
                                    <div onClick={() => { if (!chatState.conversationId) return; createDraftArtifact(); setCreateFoldout(false); }} className={`menu-item ${!chatState.conversationId ? 'menu-item-disabled' : ''}`}>
                                        <AddObject size={NAV_ICON_SIZE} />
                                        <p className="l">{appState.t("nav.newArtifact")}</p>
                                    </div>
                                )}
                                {chatState.mounted && (
                                    <div onClick={() => { if (!chatState.conversationId || tagIds.length === 0) return; createDraftEvent(); setCreateFoldout(false); }} className={`menu-item ${!chatState.conversationId || tagIds.length === 0 ? 'menu-item-disabled' : ''}`}>
                                        <AddEvent size={NAV_ICON_SIZE} />
                                        <p className="l">{appState.t("nav.newEvent")}</p>
                                    </div>
                                )}
                                <div onClick={() => {
                                    setWorkspaceModal({
                                        title: appState.t("nav.addNewClient"),
                                        body: (
                                            <TagEntry id={-1} setId={() => { setWorkspaceModal(undefined) }} isModal={true} initialValues={{ scope: 'me', permission_type: 7, attributes: { phone: '', email: '', is_client: true } }} />
                                        )
                                    });
                                    setCreateFoldout(false);
                                }} className="menu-item">
                                    <AddUser size={NAV_ICON_SIZE} />
                                    <p className="l">{appState.t("nav.addClientShort")}</p>
                                </div>
                            </div>
                            )}

                            {/* Mobile menu foldout */}
                            {appState.user && (
                            <div className={`menu md:hidden top-[2.5rem] right-[8px] min-w-[180px] ${fouldout ? "" : "hidden"}`}>
                                {appState.user?.active_organisation && (
                                    <>
                                        {[
                                            appState.user.active_organisation.permission_type >= 2 ? { action: "/workspace/tags" as string, name: appState.t("nav.tags") } : undefined,
                                            appState.user.active_organisation.permission_type >= 2 ? { action: "/workspace/artifacts" as string, name: appState.t("nav.artifacts") } : undefined,
                                            appState.user.active_organisation.permission_type >= 2 ? { action: "/workspace/documents" as string, name: appState.t("nav.documents") } : undefined,
                                            appState.user.active_organisation.permission_type >= 2 ? { action: "/workspace/events" as string, name: appState.t("nav.events") } : undefined,
                                        ].map((x) => x ? <Navlink {...x} key={x.name} /> : undefined)}
                                    </>
                                )}
                                <div className="menu-divider" />
                                <Navlink action="/workspace/chat" name={appState.t("nav.chat")} funq={() => { setConversationId(undefined) }} />
                                <Navlink action="/workspace/profile" name={appState.t("nav.profile")} />
                                {appState.user?.active_organisation ? (
                                    <Navlink action="/workspace/settings" name={appState.t("nav.settings")} />
                                ) : undefined}
                                <Navlink action="/workspace" name={appState.t("nav.home")} />
                                {appState.user?.is_super_admin && (
                                    <>
                                        <div className="menu-divider" />
                                        <Navlink action="/workspace/summarisation-tests" name={appState.t("nav.summariserEval")} />
                                    </>
                                )}
                                {chatState.mounted && appState.user?.is_super_admin && (
                                    <>
                                        <div className="menu-divider" />
                                        <div onClick={() => { chatState.setShowDebugView(!chatState.showDebugView); setFouldout(false); }} className="menu-item">
                                            <p className="l">{appState.t("nav.debugViewShort")}</p>
                                        </div>
                                    </>
                                )}
                                <div className="menu-divider" />
                                <div onClick={() => { appState.theme == "dark" ? appState.setTheme("light") : appState.setTheme("dark"); setFouldout(false); }} className="menu-item">
                                    {appState.theme == "dark" ? <Light size={NAV_ICON_SIZE} /> : <Dark size={NAV_ICON_SIZE} />}
                                    <p className="l">{appState.theme == "dark" ? appState.t("nav.lightMode") : appState.t("nav.darkMode")}</p>
                                </div>
                                <div className="menu-divider" />
                                <div className="flex flex-col px-1 py-[2px]">
                                    <small><b>{appState.user?.full_name}</b></small>
                                    <small><i>{appState.organisations?.filter(x => x.id == appState.user?.active_organisation.id).map(x => x.name)}</i></small>
                                </div>
                                <div onClick={() => { appState.user ? appState.logout() : navigate("/signin"); setFouldout(false); }} className="menu-item">
                                    {appState.user ? <Sign_out size={NAV_ICON_SIZE} /> : <Sign_in size={NAV_ICON_SIZE} />}
                                    <p className="l">{appState.user ? appState.t("nav.signOut") : appState.t("nav.signIn")}</p>
                                </div>
                            </div>
                            )}
                        </div>



                        {/* <div className="flex flex-col gap-1 justify-end mb-1 mx-1">

                            <div key={"home"}
                                onClick={() => {
                                    navigate("/")
                                }}
                                className={`flex flex-col h-full w-fit p-1 rounded-sm justify-center hover:bg-gray1 hover:text-white hover:cursor-pointer transition-colors duration-100`}>
                                <div className="group">
                                    <p className="hsub">Home</p>
                                </div>
                            </div>

                            {pages.map(x => {
                                return x ? <Navlink action={() => navigate(`/${x.variable_name}`)} name={x.variable_name} key={x.id} /> : undefined;
                            })}
                        </div> */}

                    </div>

                </nav>

                {/* New Chat Modal */}
                <Modal
                    get={newChatModal}
                    set={setNewChatModal}
                    loading={false}
                />

                {/* Workspace Selection Modal */}
                <Modal
                    get={workspaceModal}
                    set={setWorkspaceModal}
                    loading={false}
                />
            </div >
            <div className="w-full flex-1 min-h-0 overflow-hidden">

                <Outlet></Outlet>
            </div>
        </div>
    );
});

export default WorkspaceNavbar;
